
const pl = {
    message: {
        title1:'Zdalne sterowanie inteligentnym domem, technologią, bezpieczeństwem i spokojem',
        content1:' AigoSmart pomaga zdalnie zarządzać inteligentnymi urządzeniami domowymi i sterować nimi, a urządzenia mogą również postrzegać i łączyć się ze sobą. Wyzwalanie jednym kliknięciem może sprawić, że wszystkie urządzenia domowe wejdą w zaprogramowany stan, tworząc bezpieczny i bezproblemowy inteligentny dom dla Ciebie życie.',
        title2: "AigoSmart to nowa podmarka Aigostar",
        content2: "Produkty są obecnie sprzedawane do Hiszpanii, Portugalii, Francji, Włoch, Holandii, Niemiec, Finlandii, Danii, Polski, Rosji, Grecji, Austrii, Szwajcarii, Czech, Węgier, Słowacji i innych krajów i regionów europejskich.",
        content3: "Różne małe urządzenia gospodarstwa domowego, przeznaczone do prania, prania i prasowania firmy AIGOSTAR nadal zajmują",
        content4: "Pierwsza dziesiątka sprzedaży.",
        title3: "Honor marki",
        content5: "Szybko. Otwórz. Wprowadzaj innowacje. Wytrwaj",
        loading:'Ładowanie',
        submit:'Prześlij',
        contactUs: "Skontaktuj się z nami",
        privacy:"Umowa o ochronie prywatności",
        policy:"Zasady usługi",
        download:"Pobierz",

    },
}

export default pl;